import request from '@/utils/request'

// 获取巡检工单详情
export function getInspectionWorkDetail(id) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.getInspectionWorkDetail',
      method: 'get',
      params: { id }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data || {})
      } else {
        reject(new Error(res.msg || '获取工单详情失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
